export const APP = {
	sidebar: 'app-sidebar',
	sidebarToggle: 'app-sidebar-toggle',
	navDashboard: 'nav-dashboard',
	navCantieri: 'nav-cantieri',
	navTimbratura: 'nav-timbratura',
	navRapportini: 'nav-rapportini',
	navBolle: 'nav-bolle',
	navLavoratori: 'nav-lavoratori',
	navCostiFissi: 'nav-costi-fissi',
	navCashflow: 'nav-cashflow',
	navBep: 'nav-bep',
	navReportOre: 'nav-report-ore',
	navUsers: 'nav-users',
	userMenu: 'user-menu',
	logoutButton: 'app-logout-button',
	googleLoginButton: 'google-login-button',
	loadingSpinner: 'loading-spinner',
};

export const CANTIERE = {
	newButton: 'cantiere-new-button',
	saveButton: 'cantiere-save-button',
	list: 'cantiere-list',
	card: 'cantiere-card',
	tabInfo: 'cantiere-tab-info',
	tabEconomia: 'cantiere-tab-economia',
	tabCrono: 'cantiere-tab-crono',
	tabRapportini: 'cantiere-tab-rapportini',
	tabBolle: 'cantiere-tab-bolle',
	tabPresenze: 'cantiere-tab-presenze',
	tabDocumenti: 'cantiere-tab-documenti',
	exportExcel: 'cantiere-export-excel',
	exportPdf: 'cantiere-export-pdf',
};

export const TIMBRATURA = {
	tipoEntrata: 'timbratura-tipo-entrata',
	tipoUscita: 'timbratura-tipo-uscita',
	tipoInizioPausa: 'timbratura-tipo-inizio-pausa',
	tipoFinePausa: 'timbratura-tipo-fine-pausa',
	confirmButton: 'timbratura-confirm-button',
	signature: 'timbratura-signature',
	clearSignature: 'timbratura-signature-clear',
	selectCantiere: 'timbratura-select-cantiere',
	selectLavoratore: 'timbratura-select-lavoratore',
	nota: 'timbratura-nota',
	motivazione: 'timbratura-motivazione',
};

export const RAPPORTINO = {
	newButton: 'rapportino-new-button',
	saveButton: 'rapportino-save-button',
	addWorker: 'rapportino-add-worker',
};

export const BOLLA = {
	newButton: 'bolla-new-button',
	saveButton: 'bolla-save-button',
};

export const COSTOFISSO = {
	newButton: 'costofisso-new-button',
	saveButton: 'costofisso-save-button',
};
